//
// Zoom
//

//
// Flipbook
//

const flipBook = (flipBookEl) => {
    const bookEl = flipBookEl.querySelector('.book')

    // show flipbook
    flipBookEl.classList.add('loaded')

    // set current page
    bookEl.style.setProperty('--c', 0)

    // set pages count
    bookEl.querySelectorAll('.page').forEach((page, index) => {
        page.style.setProperty('--i', index)

        if (index <= 1) {
            page.classList.add('loaded')
        }
    })

    flipbookEvents(flipBookEl, bookEl)
}

const flipbookEvents = (flipBookEl, bookEl) => {
    const buttonBackEl = flipBookEl.querySelector('.button--back')
    const buttonNextEl = flipBookEl.querySelector('.button--next')
    const pageCount = flipBookEl.querySelector('.book').childElementCount

    // flipbook button back
    buttonBackEl.addEventListener('click', () => {
        const current = parseInt(bookEl.style.getPropertyValue('--c'))

        // set new current page
        bookEl.style.setProperty('--c', Math.max(0, current - 1))

        // enable next button
        buttonNextEl.removeAttribute('disabled')

        if (current - 1) {
            bookEl.classList.remove('closed')
            bookEl.classList.remove('end')
            bookEl.classList.add('open')
            buttonBackEl.removeAttribute('disabled')
        } else {
            bookEl.classList.remove('open')
            bookEl.classList.remove('end')
            bookEl.classList.add('closed')
            buttonBackEl.setAttribute('disabled', true)
        }
    })

    // flipbook button next
    buttonNextEl.addEventListener('click', () => {
        const current = parseInt(bookEl.style.getPropertyValue('--c'))

        // set new current page
        bookEl.style.setProperty('--c', Math.max(0, current + 1))

        // preload images
        bookEl.querySelectorAll('.page:not(.loaded)').forEach((page, index) => {
            if (index < 1) {
                page.classList.add('loaded')
            }
        })

        if (current + 1 < pageCount) {
            bookEl.classList.remove('closed')
            bookEl.classList.remove('end')
            bookEl.classList.add('open')
            buttonBackEl.removeAttribute('disabled')
        } else if (current + 1 === pageCount) {
            bookEl.classList.remove('closed')
            bookEl.classList.remove('open')
            bookEl.classList.add('end')
            buttonNextEl.setAttribute('disabled', true)
        } else {
            bookEl.classList.remove('end')
            bookEl.classList.remove('open')
            bookEl.classList.add('closed')
            buttonBackEl.setAttribute('disabled', true)
        }
    })

    // zoom dialog
    const dialog = document.querySelector("dialog");
    const showButton = document.querySelectorAll('.page img');
    const closeButton = document.querySelector("dialog button");

    // "Show the dialog" button opens the dialog modally
    showButton.forEach((button) => {
        button.addEventListener("click", () => {
            const clonedButton = button.cloneNode(true);
            dialog.querySelector('.dialog-content').appendChild(clonedButton);
            dialog.showModal();
        })
    })

    // "Close" button closes the dialog
    closeButton.addEventListener("click", () => {
        dialog.querySelector('img').remove()
        dialog.close()
    })
}

// init flipbook
document.querySelectorAll('.flipbook').forEach(flipBook)
